import gql from 'graphql-tag';

export const DeleteParticipantRestrictivePracticeLabel = gql`
  mutation DeleteParticipantRestrictivePracticeLabel(
    $organizationId: ID!
    $participantId: ID!
    $restrictivePracticeId: ID!
    $labelId: ID!
  ) {
    deleteParticipantRestrictivePracticeLabel(
      organizationId: $organizationId
      participantId: $participantId
      restrictivePracticeId: $restrictivePracticeId
      labelId: $labelId
    ) {
      id
    }
  }
`;
